module.exports = __webpack_public_path__ + "../resources/img/ic_error_code.00f1242f.svg";